import React from 'react';
import PropTypes, { any } from 'prop-types';

import { ToggleSwitch } from '../../../Form';

const DisplayMedalAwardsToggle = (props) => {
    const {
        field,
        formApi,
    } = props;

    return (
        <div className={`col-12`}>
            <ToggleSwitch
                id={'awardDrawMedal'}
                field={field}
                formGroupCssClass={`mb16`}
                label="Display medal awards for applicable medal draws"
                isEventEditForm

                onChange={(val) => {
                    if (!val) {
                        formApi.setValue('awardDrawMedal', false);
                        formApi.setValue('awardCombinedDivisionDrawMedal', false);
                        formApi.setError(false);
                    }
                    if (val) {
                        formApi.setValue('awardDrawMedal', true);
                        formApi.setError(false);
                    }
                }}
                reverse={false}
            />
            <div className="div div16" />

        </div>
    );
};
DisplayMedalAwardsToggle.propTypes = {
    field: PropTypes.string.isRequired,
    formApi: PropTypes.objectOf(any).isRequired,
};
export default DisplayMedalAwardsToggle;
